import React, { useEffect, useState } from 'react';
import { Send, Smartphone, Mail, Phone, AlertCircle } from 'lucide-react';
import { templates } from '../../data/templates';
export function MessageComposer() {
  const [selectedTemplate, setSelectedTemplate] = useState(templates[0]);
  const [variant, setVariant] = useState<'A' | 'B'>('A');
  const [content, setContent] = useState(templates[0].content);
  const [messagesToday, setMessagesToday] = useState(1);
  const maxMessages = 2;
  // Mock lead data for preview
  const mockLeadData = {
    '[Nombre]': 'María',
    '[Tu nombre]': 'Carlos',
    '[Ciudad]': 'Barcelona',
    '[Barrio]': 'Poble Sec',
    '[Nombre_Negocio]': 'La Tasquita de Enfrente'
  };
  useEffect(() => {
    // Apply variant logic (mocked)
    let newContent = selectedTemplate.content;
    if (variant === 'B') {
      newContent = newContent.replace('¿Le envío dos capturas', '¿Le gustaría ver dos capturas');
    }
    setContent(newContent);
  }, [selectedTemplate, variant]);
  const getPreviewContent = () => {
    let preview = content;
    Object.entries(mockLeadData).forEach(([key, value]) => {
      preview = preview.replaceAll(key, value);
    });
    return preview;
  };
  const getChannelIcon = (channel: string) => {
    switch (channel) {
      case 'WhatsApp':
        return <Smartphone className="w-4 h-4" data-id="element-202" />;
      case 'Email':
        return <Mail className="w-4 h-4" data-id="element-203" />;
      case 'Teléfono':
        return <Phone className="w-4 h-4" data-id="element-204" />;
      default:
        return <Smartphone className="w-4 h-4" data-id="element-205" />;
    }
  };
  return <div className="card overflow-hidden flex flex-col md:flex-row h-[600px]" data-id="element-206">
      {/* Left side - Editor */}
      <div className="w-full md:w-1/2 border-r border-white/5 flex flex-col bg-growthly-surface" data-id="element-207">
        <div className="p-4 border-b border-white/5 bg-growthly-panel" data-id="element-208">
          <label className="block text-[12px] font-medium text-growthly-muted mb-1" data-id="element-209">
            Plantilla
          </label>
          <select value={selectedTemplate.id} onChange={e => setSelectedTemplate(templates.find(t => t.id === e.target.value) || templates[0])} className="input-field" data-id="element-210">
            {templates.map(t => <option key={t.id} value={t.id} data-id="element-211">
                {t.name} ({t.channel})
              </option>)}
          </select>
        </div>

        <div className="p-4 border-b border-white/5 flex items-center justify-between" data-id="element-212">
          <div className="flex space-x-2" data-id="element-213">
            <button onClick={() => setVariant('A')} className={`px-3 py-1 text-[12px] font-medium rounded-md transition-colors ${variant === 'A' ? 'bg-growthly-amber text-growthly-bg' : 'bg-white/5 text-growthly-muted hover:bg-white/10'}`} data-id="element-214">
              Variante A
            </button>
            <button onClick={() => setVariant('B')} className={`px-3 py-1 text-[12px] font-medium rounded-md transition-colors ${variant === 'B' ? 'bg-growthly-amber text-growthly-bg' : 'bg-white/5 text-growthly-muted hover:bg-white/10'}`} data-id="element-215">
              Variante B
            </button>
          </div>
          <span className="text-[12px] text-growthly-amber/80" data-id="element-216">
            A/B Test Activo
          </span>
        </div>

        <div className="p-4 flex-1 flex flex-col" data-id="element-217">
          <label className="block text-[12px] font-medium text-growthly-muted mb-2" data-id="element-218">
            Mensaje
          </label>
          <textarea value={content} onChange={e => setContent(e.target.value)} className="input-field flex-1 resize-none" data-id="element-219" />

          <div className="mt-3 flex flex-wrap gap-2" data-id="element-220">
            {Object.keys(mockLeadData).map(variable => <button key={variable} className="text-[11px] font-medium bg-white/10 px-2 py-1 rounded text-growthly-text hover:bg-white/20 transition-colors" data-id="element-221">
                {variable}
              </button>)}
          </div>
        </div>

        <div className="p-4 border-t border-white/5 bg-growthly-panel flex items-center justify-between" data-id="element-222">
          <div className="flex items-center" data-id="element-223">
            <div className={`w-2 h-2 rounded-full mr-2 ${messagesToday >= maxMessages ? 'bg-growthly-red' : 'bg-growthly-green'}`} data-id="element-224"></div>
            <span className="text-[12px] font-medium text-growthly-text" data-id="element-225">
              Mensajes hoy: {messagesToday}/{maxMessages}
            </span>
          </div>
          <button disabled={messagesToday >= maxMessages} className={`btn-primary inline-flex items-center ${messagesToday >= maxMessages ? 'bg-white/10 text-growthly-muted cursor-not-allowed' : ''}`} data-id="element-226">
            <Send className="w-4 h-4 mr-2" data-id="element-227" />
            Enviar
          </button>
        </div>
      </div>

      {/* Right side - Preview (KEEP LIGHT THEME FOR WA PREVIEW) */}
      <div className="w-full md:w-1/2 bg-[#E5DDD5] flex flex-col relative" data-id="element-228">
        <div className="bg-[#075E54] text-white p-3 flex items-center shadow-md z-10" data-id="element-229">
          <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center mr-3" data-id="element-230">
            <UserIcon data-id="element-231" />
          </div>
          <div data-id="element-232">
            <div className="text-[14px] font-semibold" data-id="element-233">
              La Tasquita de Enfrente
            </div>
            <div className="text-[11px] text-white/80" data-id="element-234">María (Gerente)</div>
          </div>
        </div>

        <div className="flex-1 p-4 overflow-y-auto flex flex-col justify-end pb-8 bg-[url('https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png')] bg-repeat" data-id="element-235">
          <div className="bg-[#DCF8C6] text-[#303030] p-3 rounded-lg rounded-tr-none max-w-[85%] self-end shadow-sm relative text-[14px] whitespace-pre-wrap" data-id="element-236">
            {getPreviewContent()}
            <div className="text-[10px] text-right text-gray-500 mt-1" data-id="element-237">
              10:42 ✓✓
            </div>
          </div>
        </div>
      </div>
    </div>;
}
function UserIcon() {
  return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-238">
      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" data-id="element-239"></path>
      <circle cx="12" cy="7" r="4" data-id="element-240"></circle>
    </svg>;
}